export default __webpack_public_path__ + "static/media/imgTumorales.e9dd4965.png";